import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import React from 'react';
import { themed } from '@indeed/ifl-css';
import Tippy from '@tippyjs/react/headless';
import { Arrow } from './Arrow.js';
import { hideOnEsc } from './plugins.js';
import { useTheme, jsx } from '@emotion/react';
import transition from '../../utils/transition.js';
import warnDeprecation from '../../utils/warnDeprecation.js';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsomorphicLayoutEffect.js';
import '../../utils/warn.js';

const positions = {
  auto: {
    placement: "bottom",
    popperOptions: {
      modifiers: [{
        name: "flip",
        options: {
          fallbackPlacements: ["top", "right", "left"]
        }
      }]
    }
  },
  bottom: {
    placement: "bottom"
  },
  bottomStart: {
    placement: "bottom-start"
  },
  bottomEnd: {
    placement: "bottom-end"
  },
  top: {
    placement: "top"
  },
  topStart: {
    placement: "top-start"
  },
  topEnd: {
    placement: "top-end"
  },
  start: {
    placement: "left"
  },
  startTop: {
    placement: "left-start"
  },
  startBottom: {
    placement: "left-end"
  },
  end: {
    placement: "right"
  },
  endTop: {
    placement: "right-start"
  },
  endBottom: {
    placement: "right-end"
  }
};
const popupPositionMap = {
  center: {
    "block-end": "bottom",
    "block-start": "top",
    "inline-start": "start",
    "inline-end": "end"
  },
  start: {
    "block-end": "bottomStart",
    "block-start": "topStart",
    "inline-start": "startTop",
    "inline-end": "endTop"
  },
  end: {
    "block-end": "bottomEnd",
    "block-start": "topEnd",
    "inline-start": "startBottom",
    "inline-end": "endBottom"
  }
};
const getPosition = function (alignment, side) {
  if (alignment === void 0) {
    alignment = "center";
  }
  if (side === void 0) {
    side = "block-end";
  }
  return popupPositionMap[alignment][side];
};
const variants = {
  dark: {
    backgroundColor: "background.inverse",
    color: "foreground.inverse",
    border: "1px solid",
    borderColor: "background.inverse",
    // Uses background token because border is imperceptible
    borderRadius: "sm"
  },
  light: {
    backgroundColor: "background",
    color: "foreground.strong",
    border: "1px solid",
    borderColor: "border.weak",
    borderRadius: "sm"
  }
};
const arrowVariantProps = {
  dark: {
    backgroundColor: "background.inverse",
    borderColor: "background.inverse" // Uses background token because border is imperceptible
  },
  light: {
    backgroundColor: "background",
    borderColor: "border.weak"
  }
};
const getInverseStyles = inverse => {
  return inverse ? variants.light : variants.dark;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getInverseArrowStyles = inverse => {
  return inverse ? arrowVariantProps.light : arrowVariantProps.dark;
};
const StyledTooltipPopup = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["inverse", "visible", "direction"],
  shouldForwardProp: prop => prop !== "inverse" && prop !== "visible" && prop !== "direction",
  target: "e1ah6gey0"
} : {
  styleProps: ["inverse", "visible", "direction"],
  shouldForwardProp: prop => prop !== "inverse" && prop !== "visible" && prop !== "direction",
  target: "e1ah6gey0",
  label: "StyledTooltipPopup"
})(_ref => {
  let {
    inverse = false,
    visible = false
  } = _ref;
  return [{
    paddingInlineStart: 3,
    paddingInlineEnd: 3,
    paddingBlockStart: 1,
    paddingBlockEnd: 1,
    fontFamily: "default",
    variant: "text.level2",
    opacity: visible ? 1 : 0,
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "opacity");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    maxInlineSize: 260
  }, getInverseStyles(inverse)];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const TippyTooltip = props => {
  var _tooltipProps$trigger;
  const {
    alignment,
    arrow = true,
    arrowComponent,
    children,
    inverse = false,
    label,
    onHide,
    onMount,
    onShow,
    popupComponent,
    popupProps,
    portaled,
    role = "tooltip",
    side,
    touch,
    ...tooltipProps
  } = props;
  let {
    position
  } = props;
  const {
    plugins,
    ...otherProps
  } = tooltipProps;
  if (otherProps.appendTo !== undefined && portaled !== undefined) {
    warnDeprecation(`[Tooltip] The \`appendTo\` prop is ignored as it is replaced with the \`portaled\` prop. See https://link.indeed.tech/ifl-7-prep-guide for more information.`);
    if (portaled === true) {
      otherProps.appendTo = () => document.body;
    }
  }
  if (alignment !== undefined || side !== undefined) {
    if (position !== undefined) {
      warnDeprecation(`[Tooltip] The \`position\` prop is ignored as it is replaced with the \`alignment\` and \`side\` props. See https://link.indeed.tech/ifl-7-prep-guide for more information.`);
    }
    position = getPosition(alignment, side);
  }
  const [mounted, setMounted] = React.useState(false);
  const [visible, setVisible] = React.useState(tooltipProps.visible || false);
  const theme = useTheme();
  const direction = theme.direction || "ltr";
  const PopupComponent = popupComponent || StyledTooltipPopup;
  const ArrowComponent = arrowComponent || Arrow;
  let newPosition = position || "bottom";
  if (direction === "rtl") {
    const hash = {
      start: "end",
      end: "start",
      Start: "End",
      End: "Start"
    };
    newPosition = newPosition.replace(/start|end|Start|End/g, matched => hash[matched]);
  }
  const positionProps = positions[newPosition];
  useIsomorphicLayoutEffect(() => {
    if (tooltipProps.visible !== undefined && tooltipProps.visible !== visible) {
      setVisible(tooltipProps.visible);
    }
  }, [tooltipProps.visible, visible]);
  return jsx(Tippy, _extends({
    animation: true,
    aria: {
      content: "describedby",
      expanded: false
    },
    interactive: true,
    offset: [0, 12],
    plugins: [hideOnEsc, ...(plugins || [])],
    touch: touch ?? ((_tooltipProps$trigger = tooltipProps.trigger) == null ? void 0 : _tooltipProps$trigger.includes("touch"))
    // @ts-ignore
    ,
    onMount: instance => {
      setMounted(true);
      if (onMount) {
        // @ts-ignore
        return onMount(instance);
      }
    }
    // @ts-ignore
    ,
    onShow: instance => {
      setVisible(true);
      if (onShow) {
        // @ts-ignore
        return onShow(instance);
      }
    }
    // @ts-ignore
    ,
    onHide: instance => {
      // @ts-ignore
      const shouldHide = onHide && onHide(instance);
      if (shouldHide !== false) {
        setMounted(false);
        const timeout = window.setTimeout(() => {
          if (!instance.state.isDestroyed) {
            setVisible(false);
          }
          if (instance.state.isMounted) {
            instance.unmount();
          }
          window.clearTimeout(timeout);
        }, 300);
      }
    },
    popperOptions: {
      modifiers: [{
        name: "arrow",
        options: {
          padding: 4
        }
      }]
    }
    // @ts-ignore
    ,
    render: attrs => {
      return visible ? jsx(PopupComponent, _extends({
        direction: direction,
        role: role,
        inverse: inverse,
        visible: mounted
      }, attrs, popupProps), label, arrow ? jsx(ArrowComponent, _extends({
        "data-popper-arrow": ""
      }, getInverseArrowStyles(inverse))) : false) : null;
    }
  }, positionProps, otherProps), children);
};

export { StyledTooltipPopup, TippyTooltip };
